var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 38,
    viewBox: "0 0 18 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "prefix__a",
    width: "116.2%",
    height: "121.2%",
    x: "-8.1%",
    y: "-10.6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#E24545",
    filter: "url(#prefix__a)",
    transform: "translate(-31 -154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.899 169.75l-8.25-14.25c-.145-.217-.388-.347-.649-.347-.26 0-.504.13-.649.347l-8.25 14.25c-.134.232-.134.518 0 .75.134.232.381.375.649.375h16.5c.268 0 .515-.143.649-.375s.134-.518 0-.75zm-7.995-9.375l-.354 4.95h-1.1l-.334-4.95h1.788zm-.904 8.25c-.608 0-1.1-.493-1.1-1.1 0-.608.492-1.1 1.1-1.1.608 0 1.1.492 1.1 1.1 0 .607-.492 1.1-1.1 1.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.cca2b6ed3df3f7275f30f565cfeeb7d5.svg";
export { ForwardRef as ReactComponent };